import { Link } from "react-router-dom";
import { Users, CalendarDays, Trophy, ArrowRight } from "lucide-react";

const CARDS = [
  {
    to: "/partners",
    icon: Users,
    title: "Find a Partner",
    desc: "Match with local members who share your activities, goals, and schedule.",
    cta: "Browse partners",
    testId: "community-card-partners",
  },
  {
    to: "/events",
    icon: CalendarDays,
    title: "Join an Event",
    desc: "RSVP to walks, workouts, and workshops — or host your own for the community.",
    cta: "See upcoming events",
    testId: "community-card-events",
  },
  {
    to: "/challenges",
    icon: Trophy,
    title: "Take a Challenge",
    desc: "Log steps and active minutes, build streaks, and climb the leaderboards.",
    cta: "View challenges",
    testId: "community-card-challenges",
  },
];

export function CommunitySection() {
  return (
    <div className="iw-grid-bg-dark bg-[#081334] py-12" data-testid="community-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <div className="text-[#F45B63] text-xs font-mono font-bold uppercase mb-2">Community</div>
          <h2 className="font-heading text-3xl sm:text-4xl text-white font-bold">More than a directory. <span className="text-[#F45B63]">A community.</span></h2>
          <p className="font-body text-white/70 text-base mt-2 max-w-2xl">
            Real-world connection is the best wellness tool there is. Meet people, show up, and keep each other accountable.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CARDS.map((c) => (
            <Link key={c.to} to={c.to}
              className="group bg-[#081334] hover:bg-white/[0.06] border border-white/15 hover:border-[#F45B63] p-7 transition-[background-color,border-color]"
              data-testid={c.testId}>
              <div className="w-12 h-12 border border-[#F45B63] flex items-center justify-center mb-5">
                <c.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-heading text-base font-bold text-white mb-2">{c.title}</h3>
              <p className="font-body text-sm text-white/70 leading-relaxed mb-5">{c.desc}</p>
              <span className="font-mono text-[10px] uppercase font-semibold text-[#F45B63] flex items-center gap-1.5">
                {c.cta} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
